var React = require('react');

function NairaInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"18.5","cy":"18.5","r":"18.5","fill":"#DFE3FF","key":0}),React.createElement("rect",{"x":"12.22","y":"11","width":"14","height":"14","rx":"7","fill":"#40196D","key":1}),React.createElement("path",{"d":"M17.4639 21.1504V19.0144H16.7042V18.353H17.4639V17.6202H16.7042V16.9588H17.4639V14.8497H18.3844L20.2433 19.5327H20.0288V14.8497H20.9672V16.9588H21.7358V17.6202H20.9672V18.353H21.7358V19.0144H20.9672V21.1504H20.0556L18.1967 16.4673H18.4112V21.1504H17.4639Z","fill":"#DFE3FF","key":2})]);
}

NairaInline.defaultProps = {"width":"37","height":"37","viewBox":"0 0 37 37","fill":"none"};

module.exports = NairaInline;

NairaInline.default = NairaInline;
